import styled from 'styled-components';

export const TextWithInputsContainer = styled.div`
    width: ${({ width }) => (width ? width : '100%')};
    padding-left: ${({ paddingLeft }) => (paddingLeft ? paddingLeft : '0px')};
    padding-right: ${({ paddingRight }) => (paddingRight ? paddingRight : '')};
    text-align: ${({ textAlign }) => (textAlign ? textAlign : '')};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
`;

